module.exports = __webpack_public_path__ + "img/02_CAGUAMITA.85a0e748.png";